import React from "react";
import PropTypes from "prop-types";
import { FormLabel, GridLegacy, Typography } from "@mui/material";
import { ErrorMessage } from "@hookform/error-message";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import { Controller, useFormContext } from "react-hook-form";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";

const defaultGridSizes = {
  label: { xs: 12, sm: 4 },
  field: { xs: 12, sm: 8 },
};

function FormFieldGrid(props) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  let gridSizes = { ...defaultGridSizes };
  gridSizes.label = { ...gridSizes.label, ...props.gridSizes.label };
  gridSizes.field = { ...gridSizes.field, ...props.gridSizes.field };

  return (
    <AuthenticationWrapper
      child={(write) => {
        return (
          <>
            <GridLegacy
              item
              {...gridSizes.label}
              style={{ display: "flex", alignItems: "center", paddingTop: 16, position: "relative" }}
            >
              {props.childrenLeft}
              <FormLabel>
                {props.label ? (
                  props.label
                ) : props.tKey ? (
                  <TranslationWrapper tDefault={props.tDefault ?? props.tKey} tKey={props.tKey} />
                ) : null}
              </FormLabel>
            </GridLegacy>
            <GridLegacy item {...gridSizes.field}>
              <Controller
                control={control}
                defaultValue={props.defaultValue ?? null}
                name={props.name}
                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => {
                  const fieldProps =
                    typeof props.fieldProps === "function"
                      ? props.fieldProps({ onChange, onBlur, value, ref })
                      : props.fieldProps;
                  return (
                    <>
                      <props.Field
                        color={"primary"}
                        disabled={!write}
                        error={!!error}
                        inputRef={ref}
                        name={name}
                        onBlur={onBlur}
                        onChange={onChange}
                        style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                        value={value}
                        {...fieldProps}
                      >
                        {typeof props.fieldChildren === "function"
                          ? props.fieldChildren({ onChange, onBlur, value, ref })
                          : props.fieldChildren}
                      </props.Field>
                      <ErrorMessage
                        errors={errors}
                        name={name}
                        render={({ messages, message }) => {
                          if (messages) {
                            return Object.entries(messages).map(([type, message]) => (
                              <Typography color={"error"} key={type}>
                                {message}
                              </Typography>
                            ));
                          } else if (message) {
                            return <Typography color={"error"}>{message}</Typography>;
                          } else {
                            return null;
                          }
                        }}
                      />
                    </>
                  );
                }}
                rules={props.rules}
              />
            </GridLegacy>
          </>
        );
      }}
      permissionKey={props.permissionKey ?? props.name}
    />
  );
}

FormFieldGrid.propTypes = {
  Field: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  fieldProps: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  fieldChildren: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.array]),
  name: PropTypes.string.isRequired,
  tKey: PropTypes.string,
  tDefault: PropTypes.string,
  permissionKey: PropTypes.string,
  gridSizes: PropTypes.object,
  rules: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

FormFieldGrid.defaultProps = {
  gridSizes: { ...defaultGridSizes },
  fieldProps: {},
};

export default FormFieldGrid;
